import { lazy } from "react";

const SupplyConsumption = lazy(() => import("../pages/user/ProductionConsumption/ElectricityUsage/supply/SupplyConsumption"));
const SolarPower = lazy(() => import("../pages/user/ProductionConsumption/renewablePowerGeneration/SolarPower"));
const DemandPower = lazy(() => import("app/pages/user/ProductionConsumption/ElectricityUsage/demandPower/DemandPower"));
const UsePattern = lazy(() => import("app/pages/user/ProductionConsumption/ElectricityUsage/usePattern/UsePattern"));
const WeekHourly = lazy(() => import("app/pages/user/ProductionConsumption/ElectricityUsage/weekHourly/WeekHourly"));


// 사용자
export const pcRouter: any = [
  //생산/소비 현황

  //전기 사용량
  { path: "pc/eu/supplyconsumption", element: <SupplyConsumption /> },
  { path: 'pc/eu/demandpower', element: <DemandPower />},
  { path: "pc/eu/usepattern", element: <UsePattern /> },
  { path: "pc/eu/weekhourly", element: <WeekHourly /> },

  //고효율 설비

  //온실가스 배출량

  //신재생 발전량
  { path: "pc/renewal/solar", element: <SolarPower /> },

  //발전량 예측

  //전기 사용 요금
];